module.exports = __webpack_public_path__ + "8896f4b5184a848860f8970508cb230e.svg";